import KmModal from './modal.vue'
KmModal.install = function(vue) {
  vue.component(KmModal.name, KmModal)
}
export default KmModal



// WEBPACK FOOTER //
// ./src/ui/components/km-modal/index.js